// constants
import { TestimonialActionTypes } from "./constants";

export interface TestimonialActionType {
  type:
    | TestimonialActionTypes.API_RESPONSE_SUCCESS
    | TestimonialActionTypes.API_RESPONSE_ERROR
    | TestimonialActionTypes.UPDATE_TESTIMONIAL
    | TestimonialActionTypes.CREATE_TESTIMONIAL
    | TestimonialActionTypes.GET_TESTIMONIAL
    | TestimonialActionTypes.DELETE_TESTIMONIAL;
  payload: {} | string;
}

interface testimonialDetails {
  id: string;
  rating: string;
  comment_en: string;
  comment_ar: string;
  user_name: string;
  user_role: string;
}

// common success
export const testimonialApiResponseSuccess = (
  actionType: string,
  data: testimonialDetails | {}
): TestimonialActionType => ({
  type: TestimonialActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const testimonialApiResponseError = (
  actionType: string,
  error: string
): TestimonialActionType => ({
  type: TestimonialActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createTestimonial = (
  rating: string,
  comment_en: string,
  comment_ar: string,
  user_name: string,
  user_name_ar: string,
  courseId: string
): TestimonialActionType => ({
  type: TestimonialActionTypes.CREATE_TESTIMONIAL,
  payload: {
    rating,
    comment_en,
    comment_ar,
    user_name,
    user_name_ar,
    courseId,
  },
});

export const getTestimonial = (): TestimonialActionType => ({
  type: TestimonialActionTypes.GET_TESTIMONIAL,
  payload: {},
});

export const deleteTestimonial = (id: string): TestimonialActionType => ({
  type: TestimonialActionTypes.DELETE_TESTIMONIAL,
  payload: { id },
});
export const updateTestimonial = (
  id: string,
  rating: string,
  comment_en: string,
  comment_ar: string,
  user_name: string,
  user_name_ar: string,
  courseId: string
): TestimonialActionType => ({
  type: TestimonialActionTypes.UPDATE_TESTIMONIAL,
  payload: {
    id,
    rating,
    comment_en,
    comment_ar,
    user_name,
    user_name_ar,
    courseId,
  },
});
